import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';

import { Spinner } from '~ui-kit';

import TaskListAccordion from './TaskListAccordion';

import { setPage } from '../../actions/transferActions';

const TaskList = ({ isFetchingTasks }) => {
  const dispatch = useDispatch();
  const isDesktop = useSelector(state => state.reducer.isDesktop);
  const taskData = useSelector(state => state.transferReducers.taskData);
  const pageOffset = useSelector(state => state.transferReducers.pageOffset);

  const {
    content: items,
    totalPages,
    totalElements,
    size,
    numberOfElements,
  } = taskData || {};

  const elementOffset = pageOffset * size;

  if (!items) return null;

  if (items.length < 1) {
    return <div>Ei tilauksia.</div>;
  }

  const handlePageClick = event => {
    const newOffset = event.selected;
    window.scrollTo({
      top: 255,
      behavior: 'instant',
    });

    dispatch(setPage(newOffset));
  };

  return (
    <Container>
      {!isFetchingTasks && (
        <Meta>
          Tilaukset {elementOffset + 1}-{elementOffset + numberOfElements}{' '}
          {isDesktop && `(yhteensä ${totalElements})`}
        </Meta>
      )}
      <TaskContainer>
        {isFetchingTasks && (
          <SpinnerWrapper>
            <Spinner />
          </SpinnerWrapper>
        )}
        {items.map(task => (
          <TaskListAccordion task={task} key={task.id} />
        ))}
      </TaskContainer>
      <Paginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        pageCount={totalPages}
        previousLabel="<"
        renderOnZeroPageCount={null}
        forcePage={pageOffset}
      />
    </Container>
  );
};

const Container = styled.div``;

const Meta = styled.div`
  color: var(--primaryColor);
  margin-top: -29px;
  padding-bottom: 7px;
`;

const Paginate = styled(ReactPaginate)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  list-style: none;
  gap: 8px;

  li a {
    border-radius: 100%;
    width: 24px;
    height: 24px;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #f2f2f2;
  }
  li.previous a,
  li.next a,
  li.break a {
    border-color: transparent;
    background-color: transparent;
    font-size: 24px;
  }
  li.selected a {
    background-color: var(--lighterBlue);
    border-color: transparent;
    color: white;

    &:hover {
      color: white;
    }
  }
  li.disabled a {
    color: grey;
  }
  li.disable,
  li.disabled a {
    cursor: default;
  }
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  right: 50%;
  display: flex;
  justify-content: center;
`;

const TaskContainer = styled.div`
  position: relative;
`;

export default TaskList;
